export const LOG_OUT_LISTENERS = new Set<(userInitiated: boolean) => unknown>();

export function runLogOutSideEffects(userInitiated: boolean) {
  LOG_OUT_LISTENERS.forEach((listener) => listener(userInitiated));
}
